import React from 'react';
import { withStyles } from '@material-ui/core';
import Label from './common/Label';
import Detail from './common/Detail';
import { PHYSICAL_PIECES } from '../constants';

const styles = () => ({
  detailsContainer: {
    marginTop: 8,
    '&>div:last-child': {
      marginTop: 8
    }
  },
  container: {
    margin: '16px 0px'
  }
});

type PhysicalPiecesProps = {
  classes: Record<string, string>;
  isPhysicalPiecesChanged: boolean;
  physicalPiecesHandled?: string | number | null;
};

const PhysicalPieces: React.FC<PhysicalPiecesProps> = ({
  classes,
  isPhysicalPiecesChanged,
  physicalPiecesHandled
}) => {
  return (
    <div className={classes.container}>
      <Label labelText={PHYSICAL_PIECES.CHANGE_IN_PHYSICAL_PIECES_LABEL} />
      <div className={classes.detailsContainer}>
        <Detail
          label={PHYSICAL_PIECES.PHYSICAL_PIECES_CHANGE_QUESTION_LABEL}
          value={isPhysicalPiecesChanged ? PHYSICAL_PIECES.YES_LABEL : PHYSICAL_PIECES.NO_LABEL}
          isFullWidth
        />
        {isPhysicalPiecesChanged && (
          <Detail
            label={PHYSICAL_PIECES.PHYSICAL_PIECES_HANDLED_LABEL}
            value={physicalPiecesHandled}
            isFullWidth
          />
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(PhysicalPieces);
